import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  position: relative;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import Flex from '../../Flex';
import { TABS_BUTTON_BACKDROP_SIZE } from '../constants';
import { marginHorizontalNegative } from '../../style/margin-horizontal-negative';
import { isDefined } from '../../helpers';
var TabListWrapper = styled(Flex)(_templateObject(), function (_ref) {
  var $paddingHorizontal = _ref.$paddingHorizontal;
  return !isDefined($paddingHorizontal) ? marginHorizontalNegative(TABS_BUTTON_BACKDROP_SIZE) : '';
});
export default TabListWrapper;